module.exports = __webpack_public_path__ + "static/img/chatbot-theme-web-app.f90d837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/chatbot-theme-web-app.png
// module id = UiDp
// module chunks = 1